import styled from 'styled-components';

export const StepperBox = styled.div`
    display: grid;
    grid-template-columns: 38px 1fr 38px;
    border: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
    border-radius: 10px;
    overflow: hidden;
    height: 42px;

    &:focus-within {
        border-color: ${({ theme }) => theme.colors.antdPrimary};
        box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.colorPrimaryBg};
    }
`;

export const StepperButton = styled.button`
    border: 0;
    background: ${({ theme }) => theme.colors.colorFillAlter};
    color: ${({ theme }) => theme.colors.accentColor};
    font-size: 18px;
    cursor: pointer;
`;

export const StepperValue = styled.input`
    border: 0;
    outline: none;
    border-left: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
    border-right: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
    background: transparent;
    color: ${({ theme }) => theme.colors.antdText};
    text-align: center;
    font-weight: 700;
    padding: 0;
    min-width: 0;
    width: 100%;
    box-sizing: border-box;
    appearance: textfield;
    -moz-appearance: textfield;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`;

export const PriceCell = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    border-left: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
    border-right: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
`;

export const CurrencyPrefix = styled.span`
    color: ${({ theme }) => theme.colors.antdTextSecondary};
    font-size: 12px;
`;

export const PriceInput = styled.input<{ $accent?: boolean }>`
    border: 0;
    outline: none;
    background: transparent;
    text-align: center;
    font-weight: 700;
    padding: 0;
    min-width: 0;
    width: 70px;
    font-variant-numeric: tabular-nums;
    color: ${({ $accent, theme }) =>
        $accent ? theme.colors.accentColor : theme.colors.antdText};
`;

export const PriceField = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    height: 42px;
    padding: 0 12px;
    border: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
    border-radius: 10px;
    background: ${({ theme }) => theme.colors.colorBgContainer};

    &:hover {
        border-color: ${({ theme }) => theme.colors.secondaryColor};
    }

    &:focus-within {
        border-color: ${({ theme }) => theme.colors.accentColor};
    }
`;

export const PriceFieldInput = styled.input<{ $accent?: boolean }>`
    flex: 1;
    min-width: 0;
    border: 0;
    outline: none;
    padding: 0;
    background: transparent;
    font-size: 14px;
    font-weight: 700;
    text-align: left;
    font-variant-numeric: tabular-nums;
    color: ${({ $accent, theme }) =>
        $accent ? theme.colors.accentColor : theme.colors.antdText};

    &::placeholder {
        color: ${({ theme }) => theme.colors.colorTextPlaceholder};
    }
`;
